import { Sparkles } from "lucide-react";
import type { ClubAssociationFieldSlideProps } from "@/types/customer-onboarding";

export const ClubAssociationFieldSlide = ({ step, error, registerProps }: ClubAssociationFieldSlideProps) => {
  const Icon = step.icon;

  return (
    <div className="w-full rounded-[20px] border border-genie-border bg-white p-4 md:p-5 shadow-lg shadow-genie-primary/10">
      <label htmlFor={step.id} className="text-[12.5px] font-semibold text-gray-700">
        {step.label}
      </label>
      <div
        className={`mt-2 h-[56px] rounded-2xl border bg-genie-background/70 px-4 flex items-center gap-3 transition-colors focus-within:ring-2 focus-within:ring-genie-primary/30 focus-within:border-genie-primary ${
          error ? "border-genie-secondary" : "border-genie-border"
        }`}
      >
        <Icon className="h-5 w-5 text-gray-500 flex-shrink-0" strokeWidth={1.8} />
        <input
          id={step.id}
          type="text"
          inputMode={step.inputMode}
          autoComplete={step.autoComplete}
          placeholder={step.placeholder}
          className="min-w-0 flex-1 bg-transparent text-base font-semibold text-[#222B45] outline-none placeholder:text-gray-400 placeholder:font-normal"
          {...registerProps}
        />
      </div>
      {error ? (
        <p className="mt-2 text-xs font-medium text-genie-secondary">{error}</p>
      ) : (
        <div className="mt-3 flex items-start gap-2">
          <Sparkles className="mt-0.5 h-3.5 w-3.5 text-genie-secondary flex-shrink-0" strokeWidth={1.8} />
          <p className="text-xs text-gray-500">{step.hint}</p>
        </div>
      )}
    </div>
  );
};
